import { ProfileTabModel } from "./ProfileTab";
import { PROFILE_SECTION_EMPLOYEE } from "@/domains/profile/constants/profile-sections";

export function ProfileModel(data) {
    const { profileTabs, id } = data;

    const tabs = profileTabs.filter((tab) => tab.type === PROFILE_SECTION_EMPLOYEE);
    tabs.sort((a, b) => a.sort - b.sort);

    return {
        id,
        tabs: tabs.map(ProfileTabModel),
    };
}
